import React from 'react';
import { useRecoilState } from 'recoil';
import { Form } from 'components/UI/Forms/Form/form';
import { alertState } from 'utils/recoil/snackbar';
import { UserState } from 'utils/recoil/user';
import { withLocale } from 'utils/hocs';
import NoozApi from '../../../../../services/NoozApi';

export const ProfileAddressCreateForm = withLocale(
  ({ inputs, submitButton, successLabels, errorLabels }) => {
    const [alert, setAlert] = useRecoilState(alertState);
    const [user, setUser] = useRecoilState(UserState);

    const onAddressCreateSubmit = (data) => {
      setUser({ ...user, isLoading: true });

      if (typeof window !== 'undefined') {
        NoozApi.post('/addresses/customer', data)
          .then((response) => {
            setUser({ ...user, isLoading: false });
            if (response.data) {
              setAlert({
                ...alert,
                show: true,
                type: 'success',
                title: successLabels[0].text,
              });

              // TODO CHECK NEW ADDRESSE IS WELL ADDED
              setUser({
                ...user,
                addresses: [user.addresses, response.data],
              });
            }
          })
          .catch(({ response }) => {
            setAlert({
              ...alert,
              show: true,
              type: 'error',
              title: `${errorLabels[0].text} : ${response?.data.error}`,
            });
            setUser({ ...user, isLoading: false });
          });
      }
    };

    return (
      <Form
        onSubmit={(data) => {
          onAddressCreateSubmit(data);
        }}
        inputs={inputs}
        defaultValues={{}}
        isLoading={user.isLoading}
        submitButton={submitButton}
      />
    );
  }
);
